import { fetchQuery, graphql } from "relay-runtime"
import {
  chatLinkIdentifiersQuery,
  chatLinkIdentifiersQuery$data,
} from "@/modules/admin/advanced/services/__generated__/chatLinkIdentifiersQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chatLinkIdentifiersQuery($chatThreadId: String!) {
    appointmentIdentifiersByChatThreadId(chatThreadId: $chatThreadId) {
      appointmentId
      patientId
    }
  }
`

export type ChatLinkIdentifiers = NonNullable<chatLinkIdentifiersQuery$data["appointmentIdentifiersByChatThreadId"]>

export const fetchChatLinkIdentifiers = (chatThreadId: string): Promise<ChatLinkIdentifiers | null> =>
  fetchQuery<chatLinkIdentifiersQuery>(RelayEnvironment, query, { chatThreadId }, { fetchPolicy: "network-only" })
    .toPromise()
    .then((response) => response?.appointmentIdentifiersByChatThreadId ?? null)
